<template>
  <el-input v-bind="$attrs" :value="value" :clearable="clearable" @input="onInput" @clear="searchHandler" @keyup.enter.native="enterHandler" :style="{ width: width }" class="custom-search-input-radius">
    <i slot="prefix" class="el-input__icon icon icon-sousuo"></i>
  </el-input>
</template>

<script>


export default {
  name: 'searchInput',
  props: {
    value: [String, Number],
    width: {
      type: String,
      default: '200px',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    // 不显示右侧搜索按钮，输入时自动搜索
    authSearch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      changeHandler: () => {},
    };
  },
  methods: {
    enterHandler() {
      this.$emit('enter');
      this.$emit('fetch');
    },
    searchHandler() {
      this.$emit('search');
      this.$emit('fetch');
    },
    onChange() {
      this.searchHandler();
    },
    onInput(e) {
      this.$emit('input', e);
      this.changeHandler();
    },
  },
  created() {
    if (this.authSearch) {
      this.changeHandler = this.$debounce(this.onChange, 100);
    }
  },
};
</script>

<style lang="scss">
.custom-search-input-radius {
  height: 40px;
  .el-input__inner {
    height: 40px !important;
    line-height: 40px !important;
    border: 1px solid #E6E6E6;
    padding-left: 40px;
    border-radius: 100px;
    background: #FFFFFF;
    color: #4D4D4D;
    font-size: 14px;

    &::-webkit-input-placeholder{
        color: #4D4D4D;
    }
  }
  .el-input__prefix {
    left: 17px !important;

    .el-input__icon {
      line-height: 40px !important;
      color: #202945;
      font-size: 14px;
    }
  }
}
</style>
